import { ClientModel } from '@mercadoni/sinister/dist/lib/src/entities/clientModel'
import { Drawer } from 'antd'
import SortRadioGroup from './SortRadioGroup'

const DrawerSort = ({
  title,
  copyFilter,
  isSortDrawerOpen,
  setIsSortDrawerOpen,
  sortOptionsConfig,
  selectedSort,
  sortSelected,
}: {
  title: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  copyFilter: any
  isSortDrawerOpen: boolean
  setIsSortDrawerOpen: (isSortDrawerOpen: boolean) => void
  sortOptionsConfig: ClientModel['sortOptions']
  selectedSort: string
  sortSelected: (sort: string) => Promise<void>
}) => {
  return (
    <Drawer
      title={title}
      placement="bottom"
      onClose={() => setIsSortDrawerOpen(false)}
      open={isSortDrawerOpen}
    >
      <SortRadioGroup
        copy={copyFilter}
        sortOptionsConfig={sortOptionsConfig || []}
        defaultValue={selectedSort}
        onChangeToSort={sortSelected}
      />
    </Drawer>
  )
}

export default DrawerSort
